export const CSSTasks = [
  {
    id: 'css-grid',
    categoryId: '2',
    title: 'grid',
    code: `.block {
  display: grid;
  grid-template-columns: 200px 150px 100px;
  grid-template-rows: 200px 150px;
}

.item {
  grid-column-end: 3;
  grid-column-start: 1;
  grid-row-end: 3;
  grid-row-start: 1;
}`,
    lang: 'css',
  },
  {
    id: 'css-media-queries',
    categoryId: '2',
    title: 'media queries',
    code: `.container {
  width: 320px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (min-width: 768px) {
  .container {
    width: 768px;
    padding: 0 64px;
  }
}`,
    lang: 'css',
  },
  {
    id: 'css-back-link',
    categoryId: '2',
    title: 'back-link',
    code: `.back-link {
  position: relative;
  z-index: 1;

  display: flex;
  gap: 12px;
  align-items: center;

  padding: 5px;
  margin-left: 10px;

  font-size: 14px;
  line-height: 21px;
}`,
    lang: 'css',
  },
  {
    id: 'css-transition',
    categoryId: '2',
    title: 'transition',
    code: `.box {
  width: 100px;
  height: 100px;

  background-color: #0000ff;
  transition: width 2s, height 2s, background-color 2s, transform 2s;
}

.box:hover {
  width: 200px;
  height: 200px;

  background-color: #ffcccc;
  rotate: 180deg;
}`,
    lang: 'css',
  },
  {
    id: 'css-text-styling',
    categoryId: '2',
    title: 'text styling',
    code:
      '.box {\n' +
      '  width: fit-content;\n' +
      '  padding: 5px 10px;\n' +
      '\n' +
      "  font-family: 'Fira Code', monospace;\n" +
      '  color: var(--color-disabled);\n' +
      '\n' +
      '  background-color: var(--color-white);\n' +
      '  border: 1px solid var(--color-outline);\n' +
      '  border-radius: 5px;\n' +
      '}',
    lang: 'css',
  },
  {
    id: 'css-custom-properties',
    categoryId: '2',
    title: 'custom properties',
    code: `:root {
  --main-bg-color: brown;
}

.box {
  display: inline-block;
  width: 50px;
  margin: 10px;

  color: white;
  background-color: var(--main-bg-color);
}`,
    lang: 'css',
  },
  {
    id: 'animation',
    categoryId: '2',
    title: 'animation',
    code: `p {
  animation-duration: 3s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    width: 300%;
  }
  75% {
    width: 150%;
  }
  to {
    width: 100%;
  }
}`,
    lang: 'css',
  },
  {
    id: 'css-@font-face',
    categoryId: '2',
    title: '@font-face',
    code: `@font-face {
  font-family: "Roboto";
  font-weight: normal;
  src: local("Roboto Regular"),
  local("Roboto-Regular"),
  url("Roboto.woff2") format("woff2"),
  url("Roboto.woff") format("woff"),
}

body {
  font-family: "Roboto", sans-serif;
}`,
    lang: 'css',
  },
  {
    id: 'css-position',
    categoryId: '2',
    title: 'position',
    code: `.list li {
  position: relative;

  padding-left: 20px;
}

.list li::before {
  content: "";

  position: absolute;
  top: 0;
  left: 0;

  width: 18px;
  height: 18px;

  background: url("//unsplash.it/18/18");
}`,
    lang: 'css',
  },
]
